import { PageHeader, SystemIcon, Button } from "@justworkshr/milo-components";
import styles from "../NewHealthInsuranceApp.module.css";
import { HEALTH_APP_STATUS_CONTENT } from "../utils/contants";

const HealthApplicationSubmitted = (): JSX.Element => {
  return (
    <div className={styles.healthApplicationStatusContainer}>
      <div className={styles.titleContainer}>
        <PageHeader
          className={styles.healthApplicationStatusHeader}
          title={HEALTH_APP_STATUS_CONTENT.pageTitle}
          linkPrevious={
            <a href={HEALTH_APP_STATUS_CONTENT.url}>
              {HEALTH_APP_STATUS_CONTENT.urlText}
            </a>
          }
        />
      </div>

      <div className={styles.healthApplicationStatusContent}>
        <SystemIcon
          iconName="check"
          color="inverse"
          size="medium"
          className={styles.checkIcon}
        />
        <p>Your application was successfully submitted.</p>
        <p>We’ll review it and reach out if we need any additional info. </p>
        <p>Otherwise, we’ll send a reply in 3-5 days.</p>
        <Button
          variant="outlined"
          as="a"
          href={HEALTH_APP_STATUS_CONTENT.url}
          className={styles.button}
        >
          {HEALTH_APP_STATUS_CONTENT.footerButtonText}
        </Button>
      </div>
    </div>
  );
};

export default HealthApplicationSubmitted;
